import { render, staticRenderFns } from "./serverance-report.vue?vue&type=template&id=228fe0eb"
import script from "./serverance-report.vue?vue&type=script&lang=js"
export * from "./serverance-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports